const deleteAddDocumentCompanies = {
  toastr: 'Documento eliminado',
  toastr1: 'El documento fue eliminado con éxito'
};

export default deleteAddDocumentCompanies;
